import React, { Component } from 'react';
import DocumentTitle from "react-document-title";
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import BsyWebhookPane from "../BsyWebhookPane";
import BsyWebhookContacts from "../BsyWebhookContacts";
import BsyWebhookSystem from "../BsyWebhookSystem";
import './index.css'
import { NavLink } from "react-router-dom";
import { setPageTitle } from '../../utils/setPageTitle';

class BsyWebhookApi extends Component {

    constructor(props) {
        super(props);
        this.state = {
            apiDocList: {},
            type: "form"
        }
    }

    componentDidMount() {
        this.loadAppList()
    }

    loadAppList = () => {
        React.axios("/webapi/doclist", {}).then((res) => {
            this.setState({
                apiDocList: res.data
            })
        })
    }

    leftTitle = () => {
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    dashboardMenuCenterMenu = () => {
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="form-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }

    switchType = (type) => {
        return () => {
            this.setState({
                type: type
            })
        }
    }

    render() {
        const { apiDocList, type } = this.state
        setPageTitle("开放平台 - webhook");
        return (

            <div className="BsyWebhook">
                <BsyDashboardMenu dashboardMenuCenterMenu={this.dashboardMenuCenterMenu}
                    leftTitle={this.leftTitle} />
                <div className="webhookCont">
                    <div className="webhookMenu">
                        <div onClick={this.switchType("form")} className={type === "form" ? "menu-item select" : "menu-item"}>
                            {React.language('form')}
                        </div>
                        <div onClick={this.switchType("contacts")} className={type === "contacts" ? "menu-item select" : "menu-item"}>
                            {React.language('contacts')}
                        </div>
                        <div onClick={this.switchType("system")} className={type === "system" ? "menu-item select" : "menu-item"}>
                            {React.language('system')}
                        </div>
                    </div>
                    <div className="webhookList">
                        {
                            type === "form" && <BsyWebhookPane />
                        }
                        {
                            type === "contacts" && <BsyWebhookContacts />
                        }
                        {
                            type === "system" && <BsyWebhookSystem />
                        }
                    </div>
                </div>
            </div>

        );
    }
}

export default BsyWebhookApi;